// extracted by mini-css-extract-plugin
export default {"configurablePromoSlot":"PromoStrip_configurablePromoSlot__oA66Z","configurablePromoSlotHeader":"PromoStrip_configurablePromoSlotHeader__fS2p0"};